import { defineComponent as _defineComponent } from 'vue'
import { weeksInMonth, daysOfWeek, CONSTS, Dogspaces} from '@busy-human/k9-library';
import { computed, ref } from 'vue';
import KennelCount from './kennel-count.vue';
import KennelCountModal from './kennel-count-modal.vue';
import Modal from './Modal.vue';


type Props = {
	timeframe: { month: number, year: number }
	kennel: Dogspaces.Sizes
}
type Emits = {
	(e: 'selectEvent', eventId: string): void
	(e: 'update:timeframe', timeframe: Props["timeframe"]): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'kennel-calendar',
  props: {
    timeframe: {},
    kennel: {}
  },
  emits: ["selectEvent", "update:timeframe"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;
const emit = __emit;

const currentKennelCount = ref<null | {day: number, month: number, year: number}>(null);
function handleClick(date: Date) {
	currentKennelCount.value = {
		day: date.getDate(),
		month: date.getMonth(),
		year: date.getFullYear()
	};
	console.log(currentKennelCount.value);
}

// -- Computed
const currentWeeksInMonth = computed(() => weeksInMonth(props.timeframe.year, props.timeframe.month));

// -- user intraction
const adjustMonth = (delta = 1) => {
	const tmp = new Date(props.timeframe.year, props.timeframe.month + delta, 1);
	emit('update:timeframe', { year: tmp.getFullYear(), month: tmp.getMonth() });
};


const __returned__ = { props, emit, currentKennelCount, handleClick, currentWeeksInMonth, adjustMonth, get weeksInMonth() { return weeksInMonth }, get daysOfWeek() { return daysOfWeek }, get CONSTS() { return CONSTS }, get Dogspaces() { return Dogspaces }, computed, ref, KennelCount, KennelCountModal, Modal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})